import classNames from 'classnames';
import React from 'react';

import { ARIA_DESCRIPTION_ID } from '@components/CookieBanner/shared/utils';

import styles from './cookieBannerPanelDescription.scss';

interface CookieBannerPanelDescriptionProps {
  children: React.ReactNode;
  isMessage?: boolean;
  isShrinkedHeight?: boolean;
  parseHTML?: boolean;
}

function CookieBannerPanelDescription({
  children,
  isMessage = false,
  isShrinkedHeight = false,
  parseHTML = false
}: CookieBannerPanelDescriptionProps) {
  const containerStyles = classNames(styles.container, {
    [styles.container_isShrinkedHeight]: isShrinkedHeight
  });
  const textStyles = classNames(styles.text, {
    [styles.text_message]: isMessage
  });
  return (
    <div className={containerStyles}>
      {parseHTML ? (
        <p
          className={textStyles}
          id={ARIA_DESCRIPTION_ID}
          dangerouslySetInnerHTML={{ __html: children }}
        />
      ) : (
        <p className={textStyles} id={ARIA_DESCRIPTION_ID}>
          {children}
        </p>
      )}
    </div>
  );
}

export default CookieBannerPanelDescription;
